import { QuayDto } from '@/types/webapi';

export const IQuayServiceId = Symbol.for('IQuayService');

export interface IQuayService {
    /**
     * Fetches all quays.
     * @returns List of quays
     */
    getQuays(): Promise<QuayDto[]>;
}
